import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RoleRequestCartComponent } from '../role-request-cart/role-request-cart.component';
import { debounceTime, distinctUntilChanged, Observable, of, Subject, switchMap, takeUntil, tap, zip } from 'rxjs';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { RoleInformationComponent } from '../role-information/role-information.component';
import { AlertComponent } from 'src/app/modules/shared/components/alert/alert.component';
import { MultiOrgFilterTAComponent } from '../multi-org-filter-ta/multi-org-filter-ta.component';
import { RoleGroup } from 'src/app/modules/user-profile/models/role-request.models';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoleRequestAdvancedSearchComponent } from '../role-request-advanced-search/role-request-advanced-search.component';
import { RoleRequestSuccessComponent } from '../role-request-success/role-request-success.component';

@Component({
  selector: 'app-role-request-add-employee-role',
  imports: [CommonModule, SpinnerComponent, MultiOrgFilterTAComponent,  AlertComponent, RoleRequestSuccessComponent, RoleRequestAdvancedSearchComponent, NgSelectModule, FormsModule, RouterModule, RoleInformationComponent, CommonModule],
  templateUrl: './role-request-add-employee-role.component.html',
  styleUrl: './role-request-add-employee-role.component.css'
})
export class RoleRequestAddEmployeeRoleComponent implements OnDestroy, OnInit {
  public roleRequestService = inject(RoleRequestService);
  private spinner = inject(NgxSpinnerService);

  rolesOnCart = [];
  selectedEmployee;
  employees$: Observable<any[]>;
  search$ = new Subject<string>();
  loading = false;
  showErrorMessage: string;
  isRequestSuccess = false; isDewStaff = false;
  hasProfileAdmin = false;
  isDewOrg = false;
  profileAdminCheckbox = 2123430000;
  unsubscribe$ = new Subject();

  constructor() {
    this.employees$ = this.search$.pipe(debounceTime(300), distinctUntilChanged(), switchMap(term => this.search(term)))
  }

  ngOnInit(): void {
    this.spinner.show('employee-role-add');
    this.roleRequestService.hasAuthorizationForComponent(this.profileAdminCheckbox).subscribe((res: boolean) => {
      this.spinner.hide('employee-role-add');
      this.hasProfileAdmin = res;
    });
    this.roleRequestService.multiOrgFilters$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      this.isDewOrg = res?.selectedRoleGroup?.roleAssignGroupKey == '1';
      this.isDewStaff = false;
    });
  }

  search(selectedEmployee) {
    this.loading = true;
    return this.roleRequestService.searchEmployee(selectedEmployee, this.isDewStaff, this.isDewOrg)
      .pipe(takeUntil(this.unsubscribe$), tap(() => this.loading = false));
  }

  onCartChange(event) {
    this.rolesOnCart = event;
    this.showErrorMessage = '';
  }

  submitRoleRequest() {
    let payload = [];
    this.spinner.show('employee-role-add');
    this.rolesOnCart.forEach(role => {
      payload.push({
        personKey: this.selectedEmployee.key,
        roleKey: role.roleKey,
        usageTypeKey: 0,
        assignGroupKey: +this.roleRequestService.multiOrgFilters.selectedRoleGroup.roleAssignGroupKey,
        orgKey: this.roleRequestService.multiOrgFilters.selectedOrganization?.orgKey,
        roleRequestText: role.reason || ' ',
        roleRequestTypeKey: 1,
        effectiveDate: role.effectiveDate,
      })
    })
    this.roleRequestService.roleRequestPost(payload, this.hasProfileAdmin).subscribe(data => {
      this.spinner.hide('employee-role-add');
      this.showErrorMessage = '';
      this.isRequestSuccess = true;
    },
      err => {
        this.spinner.hide('employee-role-add');
        if(err.error?.resultMessage?.length < payload?.length) {
          this.showError("Your request was partially fulfilled. "+ err.error.resultMessage);
        } else {
          this.showError(err.error.resultMessage);
        }
      }
    )
  }

  ngOnDestroy(): void {
  }

  selectedRoleGroup: RoleGroup;
  onRoleGroupChange(event: RoleGroup) {
    this.selectedRoleGroup = event;
  }

  roleAndOrgSelected() {
    return this.roleRequestService.multiOrgFilters.selectedOrganization && this.roleRequestService.multiOrgFilters.selectedRoleGroup;
  }

  showError(message: string): void {
    this.showErrorMessage = message;
    window.scrollTo(0, 0);
  }

  showAdvancedSearch = false
  showAdvancedSearchFn(): void {
    this.showAdvancedSearch = !this.showAdvancedSearch;
  }

  emplSelected(employe) {
    this.selectedEmployee = {
      key: employe.personKey,
      firstName: employe.firstName,
      lastName: employe.lastName
    }
  }

  onDewStaffChange(event) {
    this.selectedEmployee = null;
  }

}